import { createAction, props } from '@ngrx/store';

export const LoadFilterNodesAction = createAction('[Filter] entity/load_nodes');

export const LoadFilterNodesSuccessAction = createAction('[Filter] entity/load_nodes/success');

export const LoadFilterNodesFailureAction = createAction('[Filter] entity/load_nodes/failure', props<{ error: any }>());
